import SlhNavI18n from "./src/i18n";
import { Translatable } from "./src/mixins/translatable";

export { SlhNavI18n, Translatable };
